<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="_signers">

          <template slot="header">
            <router-link :to="{name: 'master-signer-add'}" >
                <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" v-if="pms ('MasterSigner', 'create', 'b')"></vs-button>
            </router-link>
          </template>

          <template slot="thead">
            <vs-th sort-key="nameSurname" class="w-2/6">{{ $t("sections.master.dataForm.name") +" - "+ $t("sections.master.dataForm.surname") }}</vs-th>
            <vs-th sort-key="position" class="w-1/6">{{ $t("sections.master.dataForm.position") }}</vs-th>
            <vs-th sort-key="status" class="w-1/6">{{ $t("sections.master.dataForm.status") }}</vs-th>
            <vs-th sort-key="default" class="w-1/12">{{ $t("sections.master.dataForm.default") }}</vs-th>
            <vs-th sort-key="#" class="w-1/12"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="index" v-for="(row, index) in data">
              <vs-td :data="row.fullName">
                {{ row.fullName}}
              </vs-td>
              <vs-td :data="row.position">
                {{ row.position }}
              </vs-td>
              <vs-td :data="row.status">
                <vs-chip :color="getStatusColor(row.status)" class="product-order-status">{{ row.status }}</vs-chip>
              </vs-td>
              <vs-td :data="row.isChoose">
                <vs-switch color="success" v-model="isChoose" :vs-value="row.id" icon-pack="feather" vs-icon="icon-check"/>
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <router-link :to="{ name: 'master-signer-edit', params: {id: row.id } }" >
                    <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="pms ('MasterSigner', 'edit', 'b')"></vs-button>
                  </router-link>
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" v-if="pms ('MasterSigner', 'delete', 'b')" @click="del();actionID=row.id" ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  async created () {
    const vm = this
    const { getSigners } = vm
    await getSigners()
    vm.pms ('MasterSigner', 'visible', 'r')
    const obj = vm.signers.find(res => res.isChoose === true)
    vm.isChoose = ( obj ? [obj.id] : [])
    vm.tableName = 'signer'
  },
  computed: {
    ...mapMasterFields(['signers', 'status']),
    _signers () {
      if(this.signers){
        return this.signers
      }
    }
  },
  methods: {
    ...mapMasterActions(['getSigners', 'deleteSigner']),
    async del () {
      const vm = this
      const { $vs } = vm
      const { dialog, deleteSigner } = $vs
      dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept:  async () => {
          await deleteSigner({
            form: {
              id: vm.actionID
            },
            vm: vm
          })
        }
      })
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>
